import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { putNasjon } from "../../../../actions/nasjonerActions";
import {
  IsValidated,
  onChangeValidation,
} from "../../../../utils/validationUtils";
import ModalGeneric from "../../../Common/ModalGeneric";
import UpdateOpenModal from "../../CreateModals/UpdateOpenModal";
import NasjonerForm from "../../NasjonerForm";

const rules = {
  kode: "required;minLength=1;maxLength=50",
  navn: "required;minLength=1;maxLength=50",
};

function NasjonerModal({ nasjon }) {
  const dispatch = useDispatch();
  const initState = () => ({
    open: false,
    submitButtonText: "Lagre",
    id: nasjon.id,
    kode: nasjon.kode,
    navn: nasjon.navn,
    validationError: {},
  });
  const [state, setState] = useState(initState);
  const update = (patch) => setState((s) => ({ ...s, ...patch }));

  useEffect(() => {
    setState((s) => ({ ...s, kode: nasjon.kode, navn: nasjon.navn }));
  }, [nasjon]);

  const closeModal = () => setState(initState());

  const isFormValid = () => {
    const { isValid, validationError } = IsValidated(state, rules);
    update({ validationError });
    return isValid;
  };

  const handlePut = () => {
    update({ submitButtonText: "Lagrer..." });
    dispatch(putNasjon({ id: state.id, kode: state.kode, navn: state.navn }))
      .then(closeModal)
      .catch(() => update({ submitButtonText: "Lagre" }));
  };

  const saveAndClose = () => {
    if (isFormValid()) handlePut();
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const draft = { ...state, [name]: value };
    onChangeValidation(e, draft, rules);
    setState(draft);
  };

  return (
    <ModalGeneric
      modalTitle="Rediger nasjon"
      open={state.open}
      closeModal={closeModal}
      openModal={() => update({ open: true })}
      OpenModalComponent={UpdateOpenModal}
      submit={saveAndClose}
      submitButtonText={state.submitButtonText}
    >
      <NasjonerForm
        kode={state.kode}
        navn={state.navn}
        handleChange={handleChange}
        validationError={state.validationError}
        actionType="update"
      />
    </ModalGeneric>
  );
}

export default NasjonerModal;
